import { InMemoryCache } from '@apollo/client';
import type { TypedTypePolicies } from '@lingoda/quiz-graphql';

const typePolicies: TypedTypePolicies = {
    GrammarVideoAvailability: {
        keyFields: ['videoUuid'],
    },

    LingrammScore: {
        keyFields: ['grammarUuid'],
    },

    LingrammGrammar: {
        keyFields: ['grammarUuid'],

        fields: {
            score: {
                read(existing, { readField, toReference, canRead }) {
                    const ref = toReference({
                        __typename: 'LingrammScore',
                        grammarUuid: readField('grammarUuid'),
                    });

                    return canRead(ref) ? ref : existing;
                },
            },
        },
    },

    Query: {
        fields: {
            lingrammFindScore: {
                read(existing, { args, toReference, canRead }) {
                    const ref = toReference({
                        __typename: 'LingrammScore',
                        grammarUuid: args?.grammarUuid,
                    });

                    return canRead(ref) ? ref : existing;
                },
            },
        },
    },
};

export const createQuizCache = () => {
    return new InMemoryCache({ typePolicies });
};
